import React from "react";
import "./CSRGallery.css";

const CSRGalleryHeader = () => {
  return (
    <section className="csr-header back">
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          <div className="col-12 text-center">
            <h1 className="gallery-title fw-bold mb-2">
              CSR Gallery
            </h1>

            <p className="gallery-subtitle mb-0 mx-auto">
              Explore the visual journey of CSR initiatives, impact stories,
              and community transformation across Maharashtra
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CSRGalleryHeader;
